import { XMarkIcon } from '@heroicons/react/24/outline';
import { ModalHeaderProps } from '../../../types';

const ModalHeader: React.FC<ModalHeaderProps> = ({
  children,
  onClose,
  showCloseButton = true,
  className = ''
}) => {
  return (
    <div className={`flex justify-between items-center p-6 border-b border-gray-200 ${className}`}>
      <div className="text-xl font-semibold text-gray-900">
        {children}
      </div>
      {showCloseButton && onClose && (
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Close modal"
        >
          <XMarkIcon className="h-6 w-6" />
        </button>
      )}
    </div>
  );
};

export default ModalHeader; 